import React from 'react';

const MobileActionBar = ({ children }) => (
  <div
    style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 100,
      display: 'flex',
      gap: '10px',
      padding: '10px 5%',
      background: '#FFFFFF',
      borderTop: '1px solid #E0E0E0',
      boxShadow: '0px -4px 12px rgba(0, 0, 0, 0.08)'
    }}
  >
    {children}
  </div>
);

export default MobileActionBar;



// WEBPACK FOOTER //
// ./src/containers/agent/Tabs/Payments/MobileActionBar.js